import { memo } from 'react';
import { IconBlock, Label, type LabelProps } from '@direct-frontend/components';
import { type OpenApiSchemaProductVariant } from '#shared/api/schema';
import { getProductVariantStatusLabelProps } from '../../lib/status';
import { productVariantStatusLabelTestIds } from './testids';

interface ProductVariantStatusLabelProps extends Omit<LabelProps, 'children'> {
    status: undefined | OpenApiSchemaProductVariant['status'];
}

export const ProductVariantStatusLabel = memo<ProductVariantStatusLabelProps>(function VariantStatusLabel({
    'data-testid': dataTestId = productVariantStatusLabelTestIds.status,
    status,
    ...labelProps
}) {
    if (status) {
        return <Label data-testid={dataTestId} {...labelProps} {...getProductVariantStatusLabelProps(status)} />;
    }

    return (
        <Label data-testid={dataTestId} {...labelProps} addonLeft={<IconBlock size="12" color="red" />}>
            Статус неизвестен
        </Label>
    );
});
